import type {FC} from 'react';
import {memo, useCallback} from 'react';
import {Link, useNavigate} from 'react-router';

import {Observer} from 'mobx-react';

import type {GetComponentProps} from '@yourcoach/shared/utils/utility-types';

import {NotificationsButton} from '@yourcoach/shared/components/NotificationsButton';
import {SupportChatButton} from '@yourcoach/shared/components/SupportChatButton';
import {Logo} from '@yourcoach/shared/uikit/Logo';
import {TestID} from '@yourcoach/shared/utils/test-utils/data-test-id';

import localAppStore from '@src/context/appStore';
import {routerPath} from '@src/routes/path';
import {GodModeButton} from '@src/v2/components/GodModeButton';
import {HeaderRightSide} from '@src/v2/components/HeaderRightSide';
import {BreadcrumbsContainer} from '@src/v2/modules/breadcrumbs';

import styles from './styles.module.css';

interface Props {
  isWithCrumbs?: boolean;
  isWithFrom?: boolean;
  skipRootCrumb?: boolean;
}

const TopMenu: FC<Props> = ({
  isWithCrumbs,
  isWithFrom,
  skipRootCrumb = true,
}) => {
  const navigate = useNavigate();

  const handleOnClickNotification = () => {
    localAppStore.setIsTopNotificationsOpen(true);
  };

  const handleCreateSupportChat: GetComponentProps<
    typeof SupportChatButton
  >['onClick'] = useCallback(
    channel => {
      const path = routerPath.chats.$buildPath({
        searchParams: {
          cid: channel._id,
        },
      });
      const state = routerPath.chats.$buildState({
        state: {
          isDM: true,
        },
      });

      navigate(path, {state});
    },
    [navigate],
  );

  return (
    <Observer>
      {() => (
        <div className={`TopMenu ${styles.TopMenu}`}>
          <div className={styles.LeftPartTopMenu}>
            <BreadcrumbsContainer
              isWithCrumbs={isWithCrumbs}
              isWithFrom={isWithFrom}
              skipRootCrumb={skipRootCrumb}
            />
            <Link
              className={styles.MobileLogoContainer}
              to={routerPath.$buildPath({})}
            >
              <Logo size={40} />
            </Link>
          </div>
          <div className={styles.RightPartTopMenu}>
            <GodModeButton />
            <SupportChatButton onClick={handleCreateSupportChat} />
            <NotificationsButton
              badge={localAppStore!.topNotification}
              onClick={handleOnClickNotification}
              testID={TestID.menu.button.notifications}
            />
            <div className={styles.TopUserProfileContainer}>
              <HeaderRightSide />
            </div>
          </div>
        </div>
      )}
    </Observer>
  );
};

export default memo(TopMenu);
